import React, { useState, useEffect } from "react";
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from "../../../config/ui.js";
import PAGES from "../../data/PagesConstants.js";
import { useParams, useNavigate } from 'react-router-dom';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';
import FormPartial from "./FormPartial.js";
import PincodeModel from '../../models/Pincode.js';


const Edit = () => {
  const [updateApi] = getApi('updatePincode');
  const [getPincodeApi] = getApi('getPincode');
  const navigate = useNavigate();
  const params = useParams();

  const [pincodeModel, setPincodeModel] = useState(new PincodeModel());

  useEffect(()=> {
    setPincode();
  }, [])

  const setPincode = async () => {
    try {
      let pincode_data = await getPincodeApi({id: params.id}).unwrap();
      setPincodeModel(new PincodeModel(pincode_data.data.pincode, 0))
    } catch (error) {
      toast.error(error.data?.message || "Something went wrong");
      navigate(-1);
    }
  }

  // const createRecord = async (params) => {
  //   try {
  //     await createApi(params).unwrap();
  //     toast.success("Created Successfully");
  //     navigate(-1);
  //   } catch (error) {
  //     let pincodeModelObj = new PincodeModel(pincodeModel);
  //     pincodeModelObj.set_api_errors(error?.data?.data?.errors);
  //     toast.error(error?.data?.message || 'Something went wrong !');
  //   }
  // }


  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      navigate("/pincodes");
      toast.success("Pincode Updated Successfully");
    } catch(error) {
      toast.error(error?.data?.message  || 'Something went wrong !');
    }
  }
  const onFormSubmit = (params) => {
    try{
      updateRecord((new PincodeModel(pincodeModel)).toApiJson(true));
    } catch(error){
      setPincodeModel(new PincodeModel(pincodeModel));
    }
  }

  const handleBackFunction = () => {
    navigate(-1);
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditPinCodePage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "PIN Codes", url: '/pincodes' }, { label: "Edit PIN Code" }]}
    className={'edit-pin-code-page'}
  >
    <PageContentWrapper contentHeading={`Edit PIN Code`}>
      <div className="mt-4">
        <form className="row g-3" autoComplete="off">
          <FormPartial pincodeModel={pincodeModel} setPincodeModel={setPincodeModel} />
          <div className='mb-4 col-md-12'>
            <div >
              <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleBackFunction}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onFormSubmit}>Update</button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
}

export default Edit;
